import { render, staticRenderFns } from "./ApiTokenMainDialog.vue?vue&type=template&id=48e64448&scoped=true&"
import script from "./ApiTokenMainDialog.vue?vue&type=script&lang=js&"
export * from "./ApiTokenMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e64448",
  null
  
)

export default component.exports